<button
  mat-stroked-button
  class="mat-primary download-gus-data"
  [class.margin-top-20]="margin"
  (click)="onClick()"
  [disabled]="disabled"
  *ngIf="!querySent; else loader"
  [matTooltip]="'button.GUSTT' | loc"
>
  <mat-icon>download</mat-icon> {{ 'button.GUS' | loc }}
</button>

<ng-template #loader> <app-loader class="loader-smaller"></app-loader></ng-template>
